










































































































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import dataProxy from "@/services/data-proxy.service";
import {GrupaVozila, PodgrupaVozila} from "@/services/BackendProxies";
import storage from '@/services/local-storage.service';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class Vozila extends mixins(ComponentBaseMixin) {
    filterVisible = false;
    vozila = [];
    markeVozila = [];
    tipoviVozila = [];
    grupeVozila = [];
    podgrupeVozila = [];
    izabraneMarke = [];
    izabraniTipovi = [];
    izabraneGrupe = [];
    izabranePodgrupe = [];
    statusi = [];
    izabraniStatusi = [];
    garazniBroj = '';
    regOznaka = '';
    isBusy = false;
    tableColumns = [];
    tableOptions = {
        pagination: true,
        search: true,
        onClickRow: (row) => this.pregledajVozilo(row.id)
    };

    view: any = '';

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    async created() {
        this.tableColumns = [
            {
                field: 'slika',
                formatter: (slika) => `<img src="${slika || 'images/no-photo.png'}" width="64" height="64">`,
                width: 72
            },
            {field: 'markaVozila', title: this.$i18n.t('markaVozila')},
            {field: 'modelVozila', title: this.$i18n.t('modelVozila')},
            {field: 'registarskaOznaka', title: this.$i18n.t('registarskaOznaka')},
            {field: 'godinaProizvodnje', title: this.$i18n.t('godina')},
            {field: 'grupaVozila', title: this.$i18n.t('grupaVozila')},
            {field: 'podgrupaVozila', title: this.$i18n.t('podgrupaVozila')},
            {field: 'tipVozila', title: this.$i18n.t('tipVozila')},
        ];
        this.isBusy = true;
        try {
            this.markeVozila = await dataProxy.vratiMarkeVozila();
            this.tipoviVozila = await dataProxy.vratiTipoveVozila();
            this.grupeVozila = await dataProxy.vratiGrupeVozila();
            this.podgrupeVozila = this.grupeVozila.reduce((acc: PodgrupaVozila[], grupa: GrupaVozila) => acc.concat(grupa.podgrupeVozila), []);
            this.statusi = await dataProxy.vratiStatuseVozila();
            this.vozila = await this.loadData(() => dataProxy.vratiVozila())();
            this.isBusy = false;
        } catch (e) {
            this.isBusy = false;
        }

        if (storage.get('vozilaView') !== null) {
            this.view = storage.get('vozilaView');
        } else {
            this.view = 'CARD_VIEW';
        }
    }

    get postavljenFilter() {
        return this.izabraneMarke.length > 0 || this.izabraniTipovi.length > 0 || this.izabraneGrupe.length > 0
            || this.izabranePodgrupe.length > 0 || this.garazniBroj !== '' || this.izabraniStatusi.length > 0
            || this.regOznaka !== '';
    }

    get vozilaZaPrikaz() {
        let vozila = this.vozila;

        if (this.izabraniTipovi.length > 0) {
            vozila = vozila.filter(v => this.izabraniTipovi.includes(v.tipVozilaId));
        }
        if (this.izabraneGrupe.length > 0) {
            vozila = vozila.filter(v => this.izabraneGrupe.includes(v.grupaVozilaId));
        }
        if (this.izabranePodgrupe.length > 0) {
            vozila = vozila.filter(v => this.izabranePodgrupe.includes(v.podgrupaVozilaId));
        }
        if (this.izabraneMarke.length > 0) {
            vozila = vozila.filter(v => this.izabraneMarke.includes(v.markaVozilaId));
        }
        if (this.izabraniStatusi.length > 0) {
            vozila = vozila.filter(v => this.izabraniStatusi.includes(v.statusVozilaId));
        }
        if (this.garazniBroj !== '') {
            vozila = vozila.filter(v => v.garazniBroj.match(this.garazniBroj));
        }
        if (this.regOznaka !== '') {
            vozila = vozila.filter(v => v.registarskaOznaka.replace(/-|\s/g,"").match(this.regOznaka.toUpperCase().replace(/-|\s/g,"")));
        }

        return vozila;
    }

    setView(view: string) {
        this.view = view;
        storage.add('vozilaView', this.view);
    }

    kreirajVozilo() {
        this.$router.push({name: 'podaciVozila'});
    }

    pregledajVozilo(id: number) {
        this.$router.push(`/detalji-vozila/${id}`);
    }

    async download() {
      this.showInfo("Excel dokument sa spiskom vozila se kreira. Molim sačekajte");
      const url = await dataProxy.vozilaProxy.vratExportVozila();
      window.open(url, '_blank');
    }

}
